import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { LanguageTranslationService } from '../../core/services/language-translation.service';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  DataStateChangeEvent,
  GridDataResult,
  PageChangeEvent,
  RowArgs,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import {
  FileInfo,
  FileRestrictions,
  FileState,
} from '@progress/kendo-angular-upload';
import { State, process } from '@progress/kendo-data-query';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { CartService } from 'src/app/core/services/cart.service';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { ItemService } from 'src/app/core/services/item.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { ApiService } from 'src/app/core/services/api.service';
import {
  CartItem, Finish, ICartItem, IExtrusion, IFinish,
  IFilterItemRequest, IImportExcelUpload, IItemList, IUser, ItemSuggestion, IBaseResponse, IApiResultResponse,
  IAddCartToQuoteBody,
  ICartItemResponse,
  ICartLbl
} from 'src/app/core/models';
import { Observable, Subject } from 'rxjs';
import { QuoteService } from '../../core/services/quote.service';
import { UserService } from '../../core/services/user.service';
import { Info } from '../../core/common';
import { ProductService } from '../../core/services/product.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { clone, forEach } from 'lodash';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { Router } from '@angular/router';
import { V6productService } from '../../core/services/v6product.service';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit, AfterViewChecked  {

  public qtyVal: any;

  change(dataItem, event: number) {
    //this.qtyVal = event;
    this.cartLoading = true;
    dataItem.quantity = event;    
    this.handleCartItemQtyUpdate(event,dataItem);  
    
  }
  cartLblTxt: ICartLbl;
  gridHeight: string;
  @ViewChild(TooltipDirective, { static: false }) public tooltipDir: TooltipDirective;
  constructor(
    private cartService: CartService,
    private productService: ProductService,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private appNotify: AppNotifyService,
    private itemService: ItemService,
    private masterService: MasterDataService,
    private quoteService: QuoteService,
    private router: Router,
    private v6productService: V6productService, private languageTranslationService: LanguageTranslationService,
    private cdRef: ChangeDetectorRef
  ) {
    //this.createEditFormGroup = this.createEditFormGroup.bind(this);
    this.removeConfirmation = this.removeConfirmation.bind(this);
    this.imageURL = environment.imageBaseUrl + environment.imageFolder;
  }
  protected get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  imageURL: string;
  addQuoteForm: FormGroup;
  quickAddItem: any = clone({});
  public isEmptyPaintInGrid: boolean;
  public disableBtn = false;
  public showQuickAdd = false; // TODO Set to false when not working on the quick add.
  public directItemEntryFormGroup: FormGroup;
  public itemsLoading = false;
  public filteredItems: Array<ItemSuggestion> = new Array<ItemSuggestion>();
  public quickAddVirtual: any = { itemHeight: 40 };
  protected decimals: number = 0;
  protected autoCorrect: boolean = true;

  public cartview: GridDataResult;
  public gridData: ICartItem[] = [];
  public cartDiscount: number = 0;
  public pageable = true;

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      {
        controlName: "gridTextLbl1"
      },
      { controlName: "gridTextLbl2" },
      { controlName: "gridTextLbl3" },
      { controlName: "quickAddLbl" },
      { controlName: "idDescriptionLbl" },
      { controlName: "finishLbl" },
      { controlName: "setDefaultLbl" },
      { controlName: "defaultLbl" },
      { controlName: "paintLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "paintLbl" },
      { controlName: "quantityLbl" },
      { controlName: "uomLbl" },
      { controlName: "addToCartLbl" },
      { controlName: "clearSelection" },
      { controlName: "lineLbl" },
      { controlName: "unitLbl" },
      { controlName: "extrusionLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "multiplierLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "extendedPriceLbl" },
      { controlName: "quoteNameLbl" },
      { controlName: "totalPriceLbl" },
      { controlName: "importLbl" },
      { controlName: "addToQuoteLbl" },
      { controlName: "emptyCartLbl" },
      { controlName: "ProceedToCheckoutLbl" },
      { controlName: "errorMessage" },
      { controlName: "addedToCartSuccessLbl" },
      { controlName: "cartUpdatedLbl" },
      { controlName: "confirmLbl" },
      { controlName: "deleteConfirmLbl" },
      { controlName: "deleteYesLbl" },
      { controlName: "deleteNoLbl" },
      { controlName: "confirmCartDelete" },
      { controlName: "itemNumberLbl" },
      { controlName: "copyLbl" },
      { controlName: "editLbl" },
      { controlName: "cartDiscountLbl" },
    ];
    const componentName = "Cart";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.cartLblTxt = response[response.length - 1];
      console.log(response);
    }

  }


  //#endregion


  //#region label declaration
  protected cart = {
    gridTextLbl1: '* Applicable States Sales Tax will be added after the order is processed.',
    gridTextLbl2: '* Shipping Charge will be calculated at the time of order  processing.',
    gridTextLbl3: '* All painted orders will be invoiced at a minimum of $500.00  net per color.',
    quickAddLbl: 'Quick Add',
    finishLbl: 'Finish',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',
    uomLbl: 'UoM',
    lineLbl: 'Line #',
    unitLbl: 'Unit',
    itemLbl: 'Item #',
    extrusionLbl: 'Extrusion',
    descriptionLbl: 'Description',
    listPriceLbl: 'List Price',
    multiplierLbl: 'Multiplier',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    quoteNameLbl: 'Quote Name',
    totalPriceLbl: 'Total Price',
    importLbl: 'Import',
    addToQuoteLbl: 'Add To Quote',
    emptyCartLbl: 'Empty Cart',
    ProceedToCheckoutLbl: 'Proceed To Checkout',

    addedToCartSuccessLbl: 'Item has been added to the Cart!',
    cartUpdatedLbl: 'Cart has been updated!',
    confirmLbl: 'Please confirm',
    deleteConfirmLbl: 'Are you sure you want to delete product with',
    itemNumberLbl: 'Item Number',
    deleteYesLbl: 'Yes',
    deleteNoLbl: 'No',
    confirmCartDelete: '"Are you sure you want to delete everything from your cart?"',
    copyLbl: 'Copy',
    editLbl: 'Edit',
    selectedCartRemovedLbl: "Selected cart item has been removed.", //use this for translation
    errorOccuredLbl: "An Error Occurred",
    cartEmptyNowLbl: "Your Cart is empty Now.",
    cartDiscountLbl:"Price reflects your KawneerDirect Discount of:",
  }
  //#endregion


  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (
      (element.nodeName === "TH")
    ) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }
  public handlePaintFilter(event, dataItem) {
    if (event) {
      dataItem.paintValue = this.masterService.getPaintValues().filter(
        (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
      );
    }
    else {
      dataItem.paintValue = this.masterService.getPaintValues();
    }
  }
  private getItemListBody: IFilterItemRequest = {
    customerNumber: '',
    itemNumber: '',
    longItemNumber: '',
    pageNo: 1,
    searchQuery: '',
    skip: 0,
    take: 1,
    finishFilter: [],
    categoryFilter: [],
    sort: [
      {
        field: '',
        dir: 'asc',
      },
    ],
    filter: []
  };

  public paintValue: Array<any> = [];


  //public editFormGroup: FormGroup;

  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  public cartLoading = false;
  public enableEdit = true;
  public showInfo = true;
  public cartTotal = 0;
  public anchor: any;
  public offset: any = { left: 500, top: 500 };

  public gridItemToRemove: any;
  public removeAllItemsConfirmationDialog = false;


  protected get totalCartItem$(): Observable<number> {
    return this.cartService.totalCartItem;
  }

  //#region init
  ngOnInit(): void {
    this.loadLanguageTranslationData();
    // load my cart items.
    this.cartLoading = true;
    this.paintValue = this.masterService.getPaintValues();
    this.loadCartGrid();
    this.getCartDiscount();
    this.paintDisclaimerMsg = this.quoteService.paintDisclaimerMsg;
  }
  loadCartGrid() {
    const custNumber = this.userService.readUserObject.customerNumber;
    this.cartService.getItems(custNumber).subscribe((r: ICartItem[]) => {
      this.prepareSizeDropdownData(r);
      this.gridData = r;
      this.processCartGrid();
      this.cartService.totalCartItem.next(this.updateTotalCartItem());
      this.cartLoading = false;
    });
  }
  prepareSizeDropdownData(data: ICartItem[]) {
    data.forEach((item, index) => {
      if (item.availableFinishes.length > 0) {
        var tempFinish = item.availableFinishes.find(x => x.value === item.finishValue);
        if (tempFinish) {
          if (tempFinish.availableSizes.length > 0 && tempFinish.availableSizes[0].value) { item.currentSizes = tempFinish.availableSizes; }
          else { item.currentSizes = []; }
          if (tempFinish.value == "22" && item.paint == '') {
            item.isEmptyPaint = true;
            this.isEmptyPaintInGrid = true;
          }
        }
      }
    });
  }
  //#endregion
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  //#region sorting,filtering,pagination of grid
  protected gridState: State = {
    sort: [
      {
        field: 'lineNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  protected processCartGrid() {
    this.cartview = process(this.gridData, this.gridState);
    this.isPaintDisclaimerApplicable();
  }
  protected cartGridSortChange(sort): void {
    this.gridState.sort = sort;
    this.processCartGrid();
  }
  protected cartGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridState.skip = skip;
    this.gridState.take = take;
    this.processCartGrid();

  }
  protected cartGridDataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.processCartGrid();
  }

  //#endregion
  //#region Cart Grid row update/detete functions

  public selectableSettings: SelectableSettings;
  public handlePaintChange(event, dataItem: CartItem) {
    dataItem.paint = event.value;
    dataItem.paintName = event.name;
    this.updateCart(dataItem);
  }
  public handleCartItemFinishChange(event, dataItem: CartItem) {
    console.log(dataItem);
    dataItem.finishValue = event.value;
    dataItem.finish = event.name;
    dataItem.paints = [];
    dataItem.paint = '';
    dataItem.paintName = '';
    //if (event.value == 22) {
    //  dataItem.paints = this.paintValue;
    //  dataItem.paint = this.paintValue[0].value;
    //  dataItem.paintName = this.paintValue[0].name;
    //}
    dataItem.currentSizes = dataItem.availableFinishes.find(x => x.value === event.value).availableSizes;
    if (dataItem.currentSizes.length > 0) {
      dataItem.size = dataItem.currentSizes[0].value;
      dataItem.basePrice = dataItem.currentSizes[0].basePrice;
      this.updateCart(dataItem);
    }
  }
  public handleCartItemSizeChange(event, dataItem) {
    dataItem.size = event.value;
    this.updateCart(dataItem);
  }

  handleCartItemQtyUpdate($event, dataItem) {
    // save changes to server.update cart item qty cartId selected finish selected size itemnumber
    console.log('qty changed');
    this.updateCart(dataItem);
  }
  handleCartItemQtyChanged(event, dataItem: CartItem) {
    // change loacllly
    dataItem.quantity = event;
  }
  updateCart(cartItem: CartItem) {
    if (!this.validatePaintInGrid(cartItem)) {
      return;
    }
    console.log(cartItem);
    this.cartService.updateCart(cartItem).subscribe(
      (r: ICartItemResponse) => {
        this.appNotify.notify(
          NotifyType.SUCCESS,
          'Cart has been updated!'
        );
        this.itemUpdated(r);
        this.cartLoading = false;
      },
      (error) => {
        this.appNotify.notify(NotifyType.ERROR, "An Error Occured!");
        this.cartLoading = false;
      }
    );
  }

  validatePaintInGrid(cartItem: CartItem) {
    if (cartItem.finishValue == '22' && cartItem.paint == '') {
      cartItem.isEmptyPaint = true;
      this.isEmptyPaintInGrid = true;
      return false;
    }
    cartItem.isEmptyPaint = false;
    if (this.cartview.data.find(c => c.isEmptyPaint == true)) {
      this.isEmptyPaintInGrid = true;
    } else {
      this.isEmptyPaintInGrid = false;
    }
    return true;
  }

  itemUpdated(cartItemResponse: ICartItemResponse) {
    console.log(cartItemResponse);
    if (cartItemResponse.cartItemCount) {
      this.cartService.totalCartItem.next(cartItemResponse.cartItemCount);
    }
    if (cartItemResponse.modifiedCartItems) {
      cartItemResponse.modifiedCartItems.forEach((item, index) => {
        if (item.mode === 'DELETE_AND_UPDATE') {
          const dup = this.gridData.find(x => (x.cartItemCommonId === item.cartItemIdToRemove));
          item.quantity += dup.quantity;
          this.gridData = this.gridData.filter(x => (x.cartItemCommonId !== item.cartItemIdToRemove));
        }
        let temp = this.gridData.find(x => (x.cartItemCommonId === item.cartItemCommonId));
        if (temp) {
          temp.listPrice = item.listPrice;
          temp.unitPrice = item.unitPrice;
          temp.cmp = item.cmp;
          temp.quantity = item.quantity;
          temp.extendedPrice = temp.quantity * item.unitPrice;
        }
        const a = [];
        a.push(temp);
        this.prepareSizeDropdownData(a);
      })
      this.processCartGrid();
    }
  }
  //#endregion

  //#region Grid Helper
  public get cartItemsTotal(): number {
    if (this.gridData) {
      return (this.gridData as CartItem[]).map(
        item => item.extendedPrice
      ).reduce((a, b) => +(a + b).toFixed(2), 0);
    }
    return 0;
  }
  //#endregion
  //#region import Window Modal



  public userName: string;
  public userImages: Array<any>;
  public onStateChange(state: DataStateChangeEvent): void {

  }
  public setSelectableSettings(): void {
    this.selectableSettings = {
      checkboxOnly: false,
      mode: 'single',
      enabled: true
    };
  }

  //#endregion



  //#region delete item
  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      const cartItemCommonId: string = this.gridItemToRemove.cartItemCommonId;
      this.cartItemRemoveHandler(cartItemCommonId as string);
      this.isRowSelected = (e: RowArgs) => false;

    } else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.isRowSelected = (e: RowArgs) => false;
    }
  }
  protected cartItemRemoveHandler(cartItemCommonId: string) {
    this.cartService.removeItem(cartItemCommonId).subscribe((isRemoved: boolean) => {
      this.gridItemToRemove = null;
      this.appNotify.notify(NotifyType.SUCCESS, "Selected cart item has been removed.");
      if (this.gridData) {
        //This is a Local Remove
        const index = (this.gridData as ICartItem[]).findIndex(r => r.cartItemCommonId === cartItemCommonId);
        (this.gridData as ICartItem[]).splice(index, 1);
        this.processCartGrid();
        if (this.cartview.data.find(c => c.isEmptyPaint == true)) {
          this.isEmptyPaintInGrid = true;
        } else {
          this.isEmptyPaintInGrid = false;
        }
        this.cartService.totalCartItem.next(this.updateTotalCartItem())
      }

    }, error => {
      this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }
  protected updateTotalCartItem(): number {
    if (this.gridData) {
      return this.gridData.length as number;
    }
    return 0;
  }

  protected openConfirmRemoveAllDialog(): void {
    let isEmpty: boolean;
    if (this.gridData) {
      this.gridData.length === 0 ? isEmpty = true : isEmpty = false;
    }
    if (isEmpty) {
      alert(`There's nothing to remove.`);
    } else {
      this.removeAllItemsConfirmationDialog = true;
    }
  }
  public confirmRemoveAll(shouldRemoveAll: boolean): void {
    if (shouldRemoveAll) {
      this.emptyCartHandler();
      this.removeAllItemsConfirmationDialog = false;
    } else {
      this.removeAllItemsConfirmationDialog = false;
    }
  }
  protected emptyCartHandler() {
    this.cartService.emptyCart().subscribe(r => {
      this.gridData = [];
      this.processCartGrid();
      this.cartService.totalCartItem.next(this.updateTotalCartItem())
      this.isEmptyPaintInGrid = false;
      this.appNotify.notify(NotifyType.SUCCESS, "Your Cart is empty Now.")


    }, error => {
      this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
    });

  }

  //#endregion


  //#region show image region
  mySelection: any[] = [];
  public isRowSelected(e: RowArgs) { return false; }
  infoOpenedKKitem: boolean = false;
  showImageBox: boolean = false;
  selectedItem: any = clone({});
  public infoBoxCartItem: any;
  public showImageModal(item, ev): void {
    this.selectedItem = item;
    if (this.selectedItem.itemType === 1) {
      this.showImageBox = true;
      this.mySelection = [this.selectedItem.longItemNumber];
      this.isRowSelected = (e: RowArgs) => {
        return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
      };
      const objectURL = environment.imageBaseUrl + environment.imageFolder + this.selectedItem.itemNumber + "_S.gif";
      this.selectedItem.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);;

    } else if (this.selectedItem.itemType === 2) {
      this.showImageBox = true;
      this.mySelection = [this.selectedItem.cartItemCommonId];
      this.isRowSelected = (e: RowArgs) => {
        return this.mySelection.indexOf(e.dataItem.cartItemCommonId) >= 0;
      };
      this.getProductImage(this.selectedItem.cartItemCommonId);
    }
  }

  public selectedGridRow(dataItem) {
    this.mySelection = [dataItem.cartItemCommonId];
    this.isRowSelected = (e: RowArgs) => {
      return this.mySelection.indexOf(e.dataItem.cartItemCommonId) >= 0;
    };
  }
  public closeImageModal(): void {
    this.showImageBox = false;
    this.selectedItem = clone({});
    this.isRowSelected = (e: RowArgs) => false;
  }
  getProductImage(quoteItemCommonId: string) {
    const data = {
      quoteItemCommonId: quoteItemCommonId,
      width: 150,
      height: 150,
    }
    this.productService.getThumbnailImage(data).subscribe(resp => {
      let objectURL = 'data:image/jpeg;base64,' + resp;
      this.selectedItem.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    })
  }
  navigateToCopyConfigProduct(item: ICartItem) {
    this.v6productService.copyProductConfigInCart(item);
    let routepath = '/cart/copyConfiguredProduct/' + item.cartItemCommonId;
    this.router.navigate([routepath]);

  }
  navigateToEditConfigProduct(item: ICartItem) {
    this.v6productService.editProductConfigInCart(item);
    let routepath = '/cart/editConfiguredProduct/' + item.cartItemCommonId;
    this.router.navigate([routepath]);
  }
  public showPagging (pageable: boolean) {
    this.pageable = pageable;
    if (this.pageable) {
      this.gridHeight = '';
      this.gridState.take = 10;
    }
    else {
      this.gridState.take = 99;
      this.gridHeight = '570';
    }
  }
  public showImagePWA(item) {
    //debugger;
   // this.pageable = false;
    //this.selectedItem = item;
    if (item.itemType === 1) {
      //this.showImageBox = true;
     // this.mySelection = [this.selectedItem.longItemNumber];
      //this.isRowSelected = (e: RowArgs) => {
      //  return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
      //};
      const objectURL = environment.imageBaseUrl + environment.imageFolder + item.itemNumber + "_S.gif";
      item.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      //return objectURL;
      

    } else if (item.itemType === 2) {
      //this.showImageBox = true;
      //this.mySelection = [this.selectedItem.cartItemCommonId];
      //this.isRowSelected = (e: RowArgs) => {
      //  return this.mySelection.indexOf(e.dataItem.cartItemCommonId) >= 0;
      //};
      const data = {
        quoteItemCommonId: item.cartItemCommonId,
        width: 150,
        height: 150,
      }
      this.productService.getThumbnailImage(data).subscribe(resp => {
        let objectURL = 'data:image/jpeg;base64,' + resp;
        item.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //return objectURL;
      })
    }
    item.funcCall = 1;
    return item.funcCall;
  }
  //#endregion

  //#region page  primary button events(except remove)
  addToQuote() {
    //this.appNotify.notify(NotifyType.SUCCESS, 'Coming soon!!!!');    
    if (this.gridData.length > 0) {
      this.openQuoteDialog();
    }
  }
  proceedToCheckout() {
    // this.appNotify.notify(NotifyType.SUCCESS, "Coming soon!!!!");

  }
  //#endregion

  //#region import region

  public importDialog = {
    opened: false,
    dataSaved: false,
    showInfo: false,
    isSuccess: false,
    isError: false,
    successMessage: '',
    errorMessage: ' ',
    fileupload: {},
    mode: "import-to-cart"
  };
  importCompleteEvent($event) {
    this.importDialog = $event;
    if (this.importDialog.dataSaved) {
      this.loadCartGrid();
    }
  }
  public importDialogOpen() {
    this.importDialog.opened = true;
  }
  //#endregion
  //#region Quick Add Section
  itemAdded(cartItemResponse: ICartItemResponse) {
    console.log(cartItemResponse);
    if (cartItemResponse.cartItemCount) {
      this.cartService.totalCartItem.next(cartItemResponse.cartItemCount);
    }
    if (cartItemResponse.modifiedCartItems) {
      cartItemResponse.modifiedCartItems.forEach((item, index) => {
        if (item.mode === 'UPDATE') {
          let temp = this.gridData.find(x => (x.longItemNumber === item.longItemNumber && (x.paint === item.paint || x.paint==null) && !x.quoteCommonId));
          if (temp) {
            temp.quantity = (+item.quantity) + (+temp.quantity);
            temp.extendedPrice = temp.quantity * item.unitPrice;
          }
          else {
            this.gridData.push(item);//non quote item
          }
        } else if (item.mode === 'ADD') {
          const a = [];
          a.push(item);
          this.prepareSizeDropdownData(a);
          this.gridData.push(item);
        }

      })
      this.processCartGrid();
    }
  }
  toggleShowQuickAdd() {
    if (this.showQuickAdd) {
      this.showQuickAdd = false;
    }
    else {
      this.showQuickAdd = true;
    }
  }
  //#endregion
  //#region Add to quote
  quoteDialog: any = {};
  openQuoteDialog() {
    this.quoteDialog.isOpened = true;
    this.quoteDialog.mode = "cart-to-quote";
  }
  addToQuoteComplete($event) {
    this.quoteDialog = $event;
  }
  //#endregion

  getCartDiscount() {
    this.cartService.getCartDiscount().subscribe(response => {
      this.cartDiscount = response;
    });
  }

  //#region Paint Disclaimer
  shouldShowPaintDisclaimerMsg: boolean = false;
  paintDisclaimerMsg: string;
  protected isPaintDisclaimerApplicable() {
    this.shouldShowPaintDisclaimerMsg = false;
    try {
      if (this.gridData) {
        for (var i = 0; i < this.gridData.length; i++) {
          if (this.gridData[i].finishValue == "22") {
            this.shouldShowPaintDisclaimerMsg = this.quoteService.isDisclaimerMessageOfPaintApplicable(this.gridData[i].paint);
            if (this.shouldShowPaintDisclaimerMsg) {
              break;
            }
          }
        }
      }
    }
    catch (e) {
      //dont do anything
    }
  }
  //#endregion

}
